<template>
  <v-container>
    <v-row>
      <v-col cols="9">
        <UpdateContractsRadios
          requestType="OTHER_CHANGE"
        />

        <OtherChanges />
      </v-col>

      <CollectionPointRightSideCards
        :collectionPoint="collectionPoint"
        @searchInstallation="searchInstallation"
        @installationLoading="collectionPointLoading = $event"
        :eanErrorMessage="eanErrorMessage"
        :collectionPointLoading="collectionPointLoading"
        routeType="otherChanges"
      />
    </v-row>
  </v-container>
</template>

<script>
import { installationMixin } from '@/components/mixins/installationMixin';
import CollectionPointRightSideCards from '@/components/utils/CollectionPointRightSideCards.vue';
import UpdateContractsRadios from '@/components/UpdateContractsRadios.vue';
import OtherChanges from './OtherChanges.vue';

export default {
  name: 'OtherChangesDetail',
  mixins: [installationMixin],
  components: {
    OtherChanges,
    CollectionPointRightSideCards,
    UpdateContractsRadios,
  },
  created() {
    this.loadInstallation().then((response) => {
      this.redirectByVoltageLevel(response.data, 'NN');
    });
  },
};
</script>
